import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.77 15.525c-.3.29-.77.28-1.06-.02L12 11.565l-3.71 3.94c-.29.3-.76.31-1.06.02s-.31-.76-.02-1.06l4.25-4.5a.74.74 0 0 1 .54-.23.74.74 0 0 1 .54.23l4.25 4.5c.29.3.28.77-.02 1.06"
}));
const ForwardRef = forwardRef(SvgComponent);
export const MenuUpIcon = ForwardRef;